import { ref } from 'vue'
import { defineStore } from 'pinia'
import { EGwState } from '@/Workers/Gateway/gwService/gwConnection'
import { gwBridge } from '@/ContextTab/services/gwBridge'
import type { GatewaySubType } from '@/Workers/Gateway/gwService/constants'
import type { GatewaySubscriptionHubMessage } from '@/Workers/Gateway/types'
import type { SubscriptionParams } from '@/Workers/Gateway/gwService/types'


export const useGatewayStore = defineStore('gateway', () => {

  const status = ref<EGwState>(EGwState.disconnected)
  const isWorkerLoaded = ref(false)

  function setStatus(newStatus: EGwState) {
    status.value = newStatus
  }

  function setWorkerLoaded(loaded: boolean) {
    isWorkerLoaded.value = loaded
  }

  function subscribe(
    type: GatewaySubType,
    params: SubscriptionParams,
    callback: ((message: GatewaySubscriptionHubMessage) => void) | null = null,
  ) {
    gwBridge.sendMessage('subscribe', {
      contextId: window.contextId,
      type,
      params,
    })
    // instead of creating local callback register:
    if (callback) {
      gwBridge.addListener(
        'subscriptionMessage',
        (message: GatewaySubscriptionHubMessage) => {
          if (
            message.meta.subType === type
            && (
              !Object.keys(params).length
              || Object.keys(params).every((key) => message.meta.params[key] === params[key])
            )
          ) {
            callback(message)
          }
        },
      )
    }
  }

  function unsubscribe(type: GatewaySubType, params: SubscriptionParams) {
    gwBridge.sendMessage('unsubscribe', {
      contextId: window.contextId,
      type,
      params,
    })
  }

  function onLogout() {
    gwBridge.sendMessage('logout')
  }

  return {
    status,
    isWorkerLoaded,
    setStatus,
    setWorkerLoaded,
    subscribe,
    unsubscribe,
    onLogout,
  }
})
